
import { Context, createContext } from 'react';

/**
 * Stores values made available across the entire website (page and components) using the React Context API.
 * - currentLocale: define the currently used locale of the user.
 * - currentPath: define the currently viewed page path.
 */
export const AppCustomContext: Context<{
	currentLocale: string;
	currentPath: string;
}> = createContext({ currentLocale: '', currentPath: '' });
